const materialTheme = { // TODO: fix figma theme as no colour swatches are saved properly.
  primary: "#20365A",
  secondary: "#6DE4B9",
}
export default materialTheme;